import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const AllergenPresence = ApplicationRecord.extend({
  attrs: {
    ingredient: belongsTo({ type: 'recipes-ingredients' }),
    ingredient_id: attr({ type: Number }),
    id: attr({ type: Number }),
    contains: attr({ type: String }),
    allergen: attr({ type: String }),
  },
  static: {
    jsonapiType: 'recipes-allergen_presences',
  },
});

export default AllergenPresence;
